// logout-modal.component.ts
import { Component, Input } from '@angular/core';
import { AutoLogoutService } from './AutoLogoutService';

@Component({
  selector: 'app-logout-modal',
  template: `
    <div *ngIf="isLogoutActive && autoLogout.showModal" class="modal-backdrop">
      <div class="modal-content-custom">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title">Session Timeout Warning</h5>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <p *ngIf="autoLogout.countdown !== 0">Your session will expire in <strong>{{ autoLogout.countdown }}</strong> seconds due to inactivity.</p>
          <p *ngIf="autoLogout.countdown == 0">Your session has expired due to inactivity.</p>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button *ngIf="autoLogout.countdown === 0" class="btn btn-warning btn-block headerreg" (click)="confirm()">Ok</button>
          <button *ngIf="autoLogout.countdown !== 0" class="btn btn-warning btn-block headerreg" (click)="continueSession()">Continue Session</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .modal-backdrop {
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0, 0, 0, 0.5); display: flex; align-items: center; justify-content: center;
      z-index: 1050;
    }
    .modal-content-custom {
      background: white;
      border-radius: 8px;
      width: 90%;
      max-width: 400px;
      box-shadow: 0 5px 15px rgba(0,0,0,.5);
      animation: fadeIn 0.3s ease-in-out;
    }
    .modal-header, .modal-footer {
      padding: 1rem;
      border-bottom: 1px solid #dee2e6;
    }
    .modal-header {
      font-size: 1.2rem;
      font-weight: bold;
      background-color: #f8f9fa;
    }
    .modal-body {
      padding: 1rem;
    }
    .modal-footer {
      display: flex;
      justify-content: flex-end;
      gap: 0.5rem;
      border-top: 1px solid #dee2e6;
      background-color: #f8f9fa;
    }

    @keyframes fadeIn {
      from { opacity: 0; transform: scale(0.9); }
      to { opacity: 1; transform: scale(1); }
    }
  `]
})
export class LogoutModalComponent {
  @Input() isLogoutActive: boolean = false;
  constructor(public autoLogout: AutoLogoutService) {}

  confirm() {
    this.autoLogout.confirmLogout();
  }
  continueSession() {
    this.autoLogout.continueSession();
  }
}
